import React from "react";
import Layout from "../../components/layout";

import styles from "./NotSupportedPage.module.scss";

const NotSupportedPage = () => {
  const companyName = process.env.REACT_APP_COMPANY_NAME_GU;

  return (
    <Layout>
      <div className={styles.NotSupportedPage}>
        <h1 className="text-3xl font-bold text-white">{companyName}</h1>
        <p className="text-lg font-semibold text-white">
          આ પૃષ્ઠ માત્ર મોબાઇલ ઉપકરણો પર જ સમર્થિત છે.
        </p>
      </div>
    </Layout>
  );
};
export default NotSupportedPage;
